import { FC } from "react";
import classNames from "classnames";

import { ChartLabel } from "../ChartLabel/ChartLabel";

import { HeaderBlockProps } from "./HeaderBlock.type";

const HeaderBlock: FC<HeaderBlockProps> = ({ data, id, chartLabel }) => {
	const { text, align = "left", type, showChartLabel = false } = data;

	const TagName = type;

	return (
		<div id={id}>
			{showChartLabel && <ChartLabel label={chartLabel} className="mb-1" />}
			{typeof text === "string" && (
				<TagName
					className={classNames("leading-relaxed",
						{ "text-primary": type === "h2" })}
					style={{ textAlign: align }}
					dangerouslySetInnerHTML={{ __html: text }}
				/>
			)}
		</div>
	);
};

export { HeaderBlock };
